import { BaseFetch } from "../main-model"
export default class LogLoginModel extends BaseFetch {
    getLogLoginBy = (data) =>
    this.authFetch({
      url: "loglogin/getLogLoginBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}